export default "__VITE_ASSET__B16T7EhA__"